var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import UnitySplitPane from '@bit/smartworks.unity-react.unity-split-pane-react';
import UnityNotificationsHandler from './UnityNotificationsHandler';
export default class UnityNotificationsSplitPane extends Component {
    render() {
        const _a = this.props, { mainNotifications = {}, paneNotifications = {}, main, pane } = _a, splitPaneProps = __rest(_a, ["mainNotifications", "paneNotifications", "main", "pane"]);
        return (React.createElement(UnitySplitPane, Object.assign({ main: !!mainNotifications.target ? (React.createElement(UnityNotificationsHandler, Object.assign({}, mainNotifications), main)) : main, pane: !!paneNotifications.target ? (React.createElement(UnityNotificationsHandler, Object.assign({}, paneNotifications), pane)) : pane }, splitPaneProps)));
    }
}
